<template>
    <div
        class="form__modulesform_item_line"
        @mouseleave="disableLineMenu"
    >
        <div class="form__modulesform_item_line_block"></div>
        <component-button
            :class="[
                'form__modulesform_item_line_button',
                isLineMenuActive ? 'form__modulesform_item_line_button--active' : ''
            ]"
            :name="`form-modulesform-line-button-${index}`"
            :icon="!isLineMenuActive"
            :icon-name="'plus'"
            :icon-raw="true"
            :theme="''"
            @click="enableLineMenu"
        >{{ isLineMenuActive ? 'Add...' : '' }}</component-button>
        <div
            v-if="isLineMenuActive"
            class="form__modulesform_item_line_menu"
        >
            <ul>
                <li
                    v-for="(item, itemIndex) in items"
                    :key="itemIndex"
                >
                    <component-button
                        :name="`form-modulesform-line-menu-add-${item.key}`"
                        :text="true"
                        :size="'medium'"
                        :theme="'default'"
                        @click="emitAdd({ type: item.key, subType: item.subKey, index })"
                    >{{ item.name }}
                    </component-button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'form-modulesform-item-line',
  components: { ComponentButton },
  data () {
    return {
      isLineMenuActive: false
    }
  },
  props: {
    index: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    enableLineMenu () {
      this.isLineMenuActive = true
    },
    disableLineMenu () {
      this.isLineMenuActive = false
    },
    emitAdd (data) {
      this.$emit('emit-add', data)
      this.disableLineMenu()
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formmoduleformitemline";
</style>
